/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Delete_TitleInputs */



/**
* | output |
* | --- |
* | "Delete Tournament?" |
*
* @param {Tournament_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_delete_title = /** @type {((inputs?: Tournament_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Delete_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le tournoi ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Eliminar torneo?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluir Torneio?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminare Torneo?")
	return /** @type {LocalizedString} */ ("Delete Tournament?")
});